import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/containers/MainPage'
import SignIn from '@/components/Main/SignIn/SignIn'
import Dissemination from '@/components/Dissemination/Dissemination'
import DisseminationPromotion from '@/components/Dissemination/Promotion/Promotion'
import DisseminationPublications from '@/components/Dissemination/Publications/Publications'
import DisseminationSales from '@/components/Dissemination/Sales/Sales'
import Executive from '@/components/Executive/Executive'
import ExecutiveFounder from '@/components/Executive/Founder/Founder'
import ExecutiveCorpAffairs from '@/components/Executive/CorpAffairs/CorpAffairs'
import ExecutiveCEO from '@/components/Executive/CEO/CEO'
import Services from '@/components/Services/Services'
import ServicesInterns from '@/components/Services/Interns/Interns'
import ServicesBusinessConsulting from '@/components/Services/BusinessConsulting/BusinessConsulting'
import ServicesProjectManagement from '@/components/Services/ProjectManagement/ProjectManagement'
import FinanceExpenses from '@/components/Finance/Expenses/Expenses'
import FinanceIncome from '@/components/Finance/Income/Income'
import FinanceAssetsMaterialsRecords from '@/components/Finance/AssetsMaterialsRecords/AssetsMaterialsRecords'
import FinanceKPI from '@/components/Finance/KPI/KPI'
import Qualifications from '@/components/Qualifications/Qualifications'
import QualificationsEducation from '@/components/Qualifications/Education/Education'
import QualificationsControl from '@/components/Qualifications/Control/Control'
import QualificationsCertifications from '@/components/Qualifications/Certifications/Certifications'
import BusinessDevelopment from '@/components/BusinessDevelopment/BusinessDevelopment'
import BusinessDevelopmentService from '@/components/BusinessDevelopment/Service/Service'
import BusinessDevelopmentPartners from '@/components/BusinessDevelopment/Partners/Partners'
import BusinessDevelopmentClubs from '@/components/BusinessDevelopment/Clubs/Clubs'
import SettingsPosition from '@/components/Settings/PositionsList/PositionsList'
import SettingsCompanies from '@/components/Settings/Companies/Companies'
import SettingsUsers from '@/components/Settings/SettingsUsers/Users'
import Tags from '@/components/Settings/Tags/Tags'
import SettingsBankDetails from '@/components/Settings/BankDetails'
import SettingsServices from '@/components/Settings/Services/Services'
import SettingsExpenseCategories from '@/components/Settings/ExpenseCategories/ExpenseCategory'
import Logs from '@/components/Settings/Logs/Logs'
import TechnicalSupport from '@/components/TechnicalSupport/TechnicalSupport'
import ContactsList from '@/components/Dissemination/Sales/CRM/Contacts'
import Contact from '@/components/Dissemination/Sales/CRM/ContactCard/ContactCard'
import UserCard from '@/components/Settings/UserCard/UserCard'
import Soa from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ContactSoa'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import InvoicesTable from '@/components/Finance/InvoiceTable/InvoicesTable'
import BalanceClients from '@/components/Finance/Income/BalanceClients/BalanceClients'
import BalancePartners from '@/components/Finance/Income/BalancePartners/BalancePartners'
import Dashboard from '@/components/Finance/Dashboard/Dashboard'
import Funds from '@/components/Finance/Funds/Funds'
import ContactCompanyCard
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyCard/ContactCompanyCard'
import ContactsTrackingLists from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingLists'
import ContactsTrackingApartment
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingApartment'
import ContactsTrackingBirthdays
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingBirthdays'
import ContactsTrackingCard
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingCard'
import ContactsTrackingEchannel
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingEchannel'
import ContactsTrackingLicense
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingLicense'
import ContactsTrackingOffice
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingOffice'
import ContactsTrackingVisa
  from '@/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingCategories/ContactsTrackingVisa'
import EmailStats from '@/components/EmailStats/EmailStats'
import ServiceProvider from '@/components/Dissemination/Sales/CRM/ServiceProvider/ServiceProvider'
import {CRM_ENTRY_USER, CRM_SUPER_USER} from '@/constants/roles'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/settings/email-statistics',
      name: 'EmailStats',
      component: EmailStats
    },
    {
      path: '/finance/balances-of-clients',
      name: 'BalanceClients',
      component: BalanceClients,
      meta: {access: 'finance.income'}
    },
    {
      path: '/finance/balances-of-partners',
      name: 'BalancePartners',
      component: BalancePartners,
      meta: {access: 'finance.income'}
    },
    {
      path: '/main',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/',
      name: 'SingIn',
      component: SignIn
    },
    {
      path: '/dissemination',
      name: 'Dissemination',
      component: Dissemination,
      meta: {access: 'dissemination.dissemination'}
    },
    {
      path: '/dissemination/promotion',
      name: 'DisseminationPromotion',
      component: DisseminationPromotion,
      meta: {access: 'dissemination.promotionMarketing'}
    },
    {
      path: '/dissemination/publications',
      name: 'DisseminationPublications',
      component: DisseminationPublications,
      meta: {access: 'dissemination.publicationsPR'}
    },
    {
      path: '/dissemination/sales',
      name: 'DisseminationSales',
      component: DisseminationSales,
      meta: {access: 'dissemination.salesCRM'}
    },
    {
      path: '/dissemination/sales/contacts/:tabId(clients|partners|vendors)/:statusTabId',
      name: 'ContactsList',
      component: ContactsList,
      meta: {access: 'dissemination.salesCRM', accessRoles: [CRM_SUPER_USER, CRM_ENTRY_USER]}
    },
    {
      path: '/dissemination/sales/contact/:id',
      name: 'ContactCard',
      component: Contact,
      props: true,
      meta: {access: 'dissemination.salesCRM', accessRoles: [CRM_SUPER_USER, CRM_ENTRY_USER]},
      children: [
        {
          name: 'CompanyContact',
          path: 'company/:company',
          component: ContactCompanyCard,
          meta: {accessRoles: [CRM_SUPER_USER, CRM_ENTRY_USER]}
        }
      ]
    },
    {
      path: '/settings/users/user/:id',
      name: 'UserCard',
      component: UserCard,
      props: true,
      meta: {access: 'dissemination.salesCRM'}
    },
    {
      path: '/dissemination/sales/service-provider/:id',
      name: 'ContactServiceProvider',
      component: ServiceProvider,
      props: true,
      meta: {access: 'dissemination.salesCRM'}
    },
    {
      path: '/dissemination/sales/contacts/tracking-list',
      name: 'ContactsTrackingLists',
      component: ContactsTrackingLists,
      meta: {access: 'dissemination.salesCRM'},
      children: [
        {
          name: 'ContactsTrackingApartment',
          path: 'apartments',
          component: ContactsTrackingApartment
        },
        {
          name: 'ContactsTrackingBirthdays',
          path: 'birthdays',
          component: ContactsTrackingBirthdays
        },
        {
          name: 'ContactsTrackingCard',
          path: 'cards',
          component: ContactsTrackingCard
        },
        {
          name: 'ContactsTrackingEchannel',
          path: 'e-channels',
          component: ContactsTrackingEchannel
        },
        {
          name: 'ContactsTrackingLicense',
          path: 'licenses',
          component: ContactsTrackingLicense
        },
        {
          name: 'ContactsTrackingOffice',
          path: 'offices',
          component: ContactsTrackingOffice
        },
        {
          name: 'ContactsTrackingVisa',
          path: 'visas',
          component: ContactsTrackingVisa
        }
      ]
    },
    {
      path: '/dissemination/sales/soa/:id',
      name: 'Soa',
      component: Soa,
      meta: {access: 'dissemination.salesCRM'}
    },
    {
      path: '/dissemination/sales/proforma-invoice/:clientType/:id',
      name: 'ProformaInvoice',
      component: ProformaInvoice,
      meta: {access: 'dissemination.salesCRM'}
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      meta: {access: 'services.services'}
    },
    {
      path: '/services/interns',
      name: 'ServicesInterns',
      component: ServicesInterns,
      meta: {access: 'services.interns'}
    },
    {
      path: '/services/project-management',
      name: 'ServicesProjectManagement',
      component: ServicesProjectManagement,
      meta: {access: 'services.projectManagement'}
    },
    {
      path: '/services/business-consulting',
      name: 'ServicesBusinessConsulting',
      component: ServicesBusinessConsulting,
      meta: {access: 'services.businessConsulting'}
    },
    {
      path: '/finance',
      name: 'Dashboard',
      component: Dashboard,
      meta: {access: 'finance.finance'}
    },
    {
      path: '/finance/funds-table',
      name: 'Funds',
      component: Funds,
      meta: {access: 'finance.finance'}
    },
    {
      path: '/finance/income/:tab',
      name: 'FinanceIncome',
      props: (route) => ({activeTable: route.params.activeTable}),
      component: FinanceIncome,
      meta: {access: 'finance.income'}
    },
    {
      path: '/finance/invoices',
      name: 'InvoicesTable',
      component: InvoicesTable,
      meta: {access: 'finance.income'}
    },
    {
      path: '/finance/expenses',
      name: 'FinanceExpenses',
      component: FinanceExpenses,
      meta: {access: 'finance.expenses'}
    },
    {
      path: '/finance/assets-materials-records',
      name: 'FinanceAssetsMaterialsRecords',
      component: FinanceAssetsMaterialsRecords,
      meta: {access: 'finance.assetsMaterialsRecords'}
    },
    {
      path: '/finance/KPIs',
      name: 'FinanceKPI',
      component: FinanceKPI,
      meta: {access: 'finance.finance'}
    },
    {
      path: '/finance/services',
      name: 'SettingsServices',
      component: SettingsServices,
      meta: {access: 'finance.financeServices'}
    },
    {
      path: '/qualifications',
      name: 'Qualifications',
      component: Qualifications,
      meta: {access: 'qualifications.qualifications'}
    },
    {
      path: '/qualifications/control',
      name: 'QualificationsControl',
      component: QualificationsControl,
      meta: {access: 'qualifications.qualityControl'}
    },
    {
      path: '/qualifications/education',
      name: 'QualificationsEducation',
      component: QualificationsEducation,
      meta: {access: 'qualifications.educationAcademy'}
    },
    {
      path: '/qualifications/certifications',
      name: 'QualificationsCertifications',
      component: QualificationsCertifications,
      meta: {access: 'qualifications.certificationsAwards'}
    },
    {
      path: '/business-development',
      name: 'BusinessDevelopment',
      component: BusinessDevelopment,
      meta: {access: 'businessDevelopment.businessDevelopment'}
    },
    {
      path: '/business-development/partners',
      name: 'BusinessDevelopmentPartners',
      component: BusinessDevelopmentPartners,
      meta: {access: 'businessDevelopment.partnersAndReferals'}
    },
    {
      path: '/business-development/clubs',
      name: 'BusinessDevelopmentClubs',
      component: BusinessDevelopmentClubs,
      meta: {access: 'businessDevelopment.businessClubsAssociacions'}
    },
    {
      path: '/business-development/service',
      name: 'BusinessDevelopmentService',
      component: BusinessDevelopmentService,
      meta: {access: 'businessDevelopment.publicInformationService'}
    },
    {
      path: '/executive',
      name: 'Executive',
      component: Executive,
      meta: {access: 'executive.executive'}
    },
    {
      path: '/executive/founder',
      name: 'ExecutiveFounder',
      component: ExecutiveFounder,
      meta: {access: 'executive.officeOfFounder'}
    },
    {
      path: '/executive/corp-affairs',
      name: 'ExecutiveCorpAffairs',
      component: ExecutiveCorpAffairs,
      meta: {access: 'executive.officeOfCorpAffairs'}
    },
    {
      path: '/executive/ceo',
      name: 'ExecutiveCEO',
      component: ExecutiveCEO,
      meta: {access: 'executive.officeOfTheCEO'}
    },
    {
      path: '/settings/users',
      name: 'SettingsUsers',
      component: SettingsUsers
    },
    {
      path: '/settings/tags',
      name: 'Tags',
      component: Tags
    },
    {
      path: '/settings/logs',
      name: 'SettingsLogs',
      component: Logs
    },
    {
      path: '/settings/technical-support',
      name: 'TechnicalSupport',
      component: TechnicalSupport
    },
    {
      path: '/settings/companies',
      name: 'SettingsCompanies',
      component: SettingsCompanies
    },
    {
      path: '/settings/position',
      name: 'SettingsPosition',
      component: SettingsPosition
    },
    {
      path: '/settings/bank-details',
      name: 'SettingsBankDetails',
      component: SettingsBankDetails
    },
    /*    {
      path: '/settings/services',
      name: 'SettingsServices',
      component: SettingsServices
    }, */
    {
      path: '/settings/expense-categories',
      name: 'SettingsExpenseCategories',
      component: SettingsExpenseCategories
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js